<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-14 14:12:01
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/Durations.vue
-->
<template>
    <div class="mt-5">
        <label class="block text-white text-sm mb-[10px]">
            {{ t('tools.duration') }}
        </label>
        <div
            class="flex flex-nowrap gap-1 hidden-scrollbar overflow-y-auto sm:gap-2 gap-x-1"
        >
            <button
                v-for="item in props.duration_list"
                :key="item"
                @click="duration = item"
                :class="[
                    'flex flex-shrink-0   w-[112px] h-[50px] border border-transparent cursor-pointer  flex-col items-center justify-center gap-[10px] rounded-[10px] text-sm duration-300  p-[10px]  ',
                    duration !== item
                        ? 'bg-tool-default-black border border-white/[.06] hover:border-white/30'
                        : '!border-white/50 !bg-white/10',
                ]"
            >
                <span
                    :class="[
                        'text-xs font-medium transition-colors duration-200',
                        duration === item ? 'text-white' : 'text-[#999]',
                    ]"
                >
                    {{ item }}s
                </span>
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from '../../composables/useI18n'

const props = withDefaults(
    defineProps<{
        duration_list: Array<any>
    }>(),
    {
        duration_list: () => [],
    }
)

const { t, locale } = useI18n()

const duration = defineModel('duration')
</script>
<style scoped lang="less">
.hidden-scrollbar {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
    }
}
</style>
